"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formLabelColorTheme = exports.descriptionVariantProps = void 0;
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const formLabelColorTheme = (0, _sdsThemeInternal.themed)({
  color: {
    error: (0, _designTokensReact.color)("color--text--error--weak"),
    success: {
      "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--weak"),
      "ursa-light": (0, _designTokensReact.color)("color--text--success--weak")
    },
    warn: {
      "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--weak"),
      "ursa-light": (0, _designTokensReact.color)("color--text--warning--weak")
    },
    info: (0, _designTokensReact.color)("color--text--neutral--weak"),
    waiting: (0, _designTokensReact.color)("color--text--neutral--weak")
  }
});
exports.formLabelColorTheme = formLabelColorTheme;
const descriptionVariantProps = (0, _sdsThemeInternal.themed)({
  "lodestar-light": "bodyText",
  "ursa-light": "Inter--12px--400w"
});
exports.descriptionVariantProps = descriptionVariantProps;
//# sourceMappingURL=formLabelColorTheme.js.map